import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getNotificationMetaSliceContent = createAsyncThunk('/notificationMetas/content', async () => {
	const response = await axios.post(`${API_URL}/getNotificationMetaData`);
    console.log(response.data);
	return response;
})

export const notificationMetaSlice = createSlice({
    name: 'notificationMetas',
    initialState: {
        isLoading: false,
        notificationMetas : []
    },
    reducers: {
    },
    extraReducers: {
		[getNotificationMetaSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getNotificationMetaSliceContent.fulfilled]: (state, action) => {
			state.notificationMetas = action.payload.data
			state.isLoading = false
		},
		[getNotificationMetaSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default notificationMetaSlice.reducer